module.exports = __webpack_public_path__ + "img/logo-WC-microsite.f2416bfd.svg";